import { initializeApp } from 'firebase/app';
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut as fbSignOut,
  onIdTokenChanged,
  type User,
} from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const firebaseApp = initializeApp(firebaseConfig);
export const auth = getAuth(firebaseApp);
export const storage = getStorage(firebaseApp);

const provider = new GoogleAuthProvider();
provider.setCustomParameters({
  hd: 'just1label.com', // hint Google to filter to Workspace accounts
  prompt: 'select_account',
});

export async function signInWithGoogle(): Promise<User> {
  const result = await signInWithPopup(auth, provider);
  if (!result.user.email?.endsWith('@just1label.com')) {
    await fbSignOut(auth);
    throw new Error('Only @just1label.com accounts are permitted.');
  }
  return result.user;
}

export async function signOut(): Promise<void> {
  await fbSignOut(auth);
}

export { onIdTokenChanged };
export type { User };
